module.exports = __webpack_public_path__ + "static/media/Molly Butz Headshot_1685622049670.9f665259.jpeg";